import { render, staticRenderFns } from "./quantityRanking.vue?vue&type=template&id=6ac8ee01&scoped=true&"
import script from "./quantityRanking.vue?vue&type=script&lang=js&"
export * from "./quantityRanking.vue?vue&type=script&lang=js&"
import style0 from "./quantityRanking.vue?vue&type=style&index=0&id=6ac8ee01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8ee01",
  null
  
)

export default component.exports